// extracted by mini-css-extract-plugin
export default {"info":"src-components-base-Info-style__JsEsL__info","caption":"src-components-base-Info-style__dldXH__caption","icon":"src-components-base-Info-style__gb847__icon"};